import { render, staticRenderFns } from "./RegistrationRequestCommonInfoEdit.vue?vue&type=template&id=219659bc&scoped=true"
import script from "./RegistrationRequestCommonInfoEdit.vue?vue&type=script&lang=js"
export * from "./RegistrationRequestCommonInfoEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219659bc",
  null
  
)

export default component.exports